module.exports = __webpack_public_path__ + "img/fbd7bd2.jpg";